import { BaseApi, cancelInit, CancelTokenKeyCommit } from '@/main/baseApi';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { DMS_MODULE, NAME } from './constants';


class HromKoresprovider extends BaseApi {
	tableData(filter?: object, { cancelTokenKey, commit }: CancelTokenKeyCommit = cancelInit) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.post(`${this.apiPath}/Rows`, filter, { cancelPtr });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}
}

export const apiProvider = new HromKoresprovider(DMS_MODULE, NAME);
